module.exports = __webpack_public_path__ + "img/f3-card-1.118724c3.png";